import React from "react";
const TONES = { blue: "--ac-blue", green: "--ac-green", amber: "--ac-amber", red: "--ac-red", violet: "--ac-violet", teal: "--ac-teal", indigo: "--ac-indigo", gold: "--ac-amber-3" };

export function StatusPill({ children, tone = "blue", style = {} }) {
  const c = "var(" + (TONES[tone] || TONES.blue) + ")";
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", height: "var(--h-pill)", padding: "0 9px",
      borderRadius: "var(--r-pill)",
      background: "color-mix(in srgb, " + c + " 16%, transparent)",
      border: "1px solid color-mix(in srgb, " + c + " 42%, transparent)",
      fontSize: "var(--fs-11)", fontWeight: "var(--fw-medium)", color: c, whiteSpace: "nowrap", ...style,
    }}>{children}</span>
  );
}
